document.addEventListener('DOMContentLoaded', function () {
  // const x = document.querySelectorAll('.dbtfy-show-second-image-on-hover');
  // console.log('🚀 ~ x:', x);
  // x.forEach((e) => {
  //   e.remove();
  // });

  // const y = document.querySelectorAll('.dbtfy-ratio');
  // y.forEach((e) => {
  //   console.log(e);
  //   e.style.setProperty('--ratio-percent', '70%');
  // });

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (cart) {
    if (cart.source === 'cart-items') {
      Debutify.cart = cart.cartData;
    } else if (cart.source === 'product-form') {
      if (Debutify.settings.dbtfy_skip_cart) {
        window.location.href = '/checkout';
      } else {
        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((response) => {
            Debutify.cart = response;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  });
});



/* =========================================================
   DEBUTIFY CART INTEGRATION
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.cartUpdate
  ) {

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (cart) {

      if (!cart) return;

      /*
       * Keep Debutify cart state updated.
       */
      if (cart.source === 'cart-items') {

        Debutify.cart = cart.cartData || cart;

      } else {

        /*
         * Get the latest cart from Shopify.
         */
        fetch(window.Shopify.routes.root + 'cart.js', {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json'
          }
        })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Unable to load cart');
          }

          return response.json();
        })
        .then(function (cartData) {

          Debutify.cart = cartData;

        })
        .catch(function (error) {

          console.error(
            'Debutify cart update error:',
            error
          );

        });

      }

    });

  }

});


/* =========================================================
   REMOVE VELOCITY EMI FROM STICKY BUY BAR
   ========================================================= */

(function () {

  'use strict';


  function removeStickyEMI() {

    const stickyBars =
      document.querySelectorAll(
        '.product-form-buy-button'
      );


    stickyBars.forEach(function (stickyBar) {


      /*
       * Remove known Velocity EMI elements.
       */

      const knownElements =
        stickyBar.querySelectorAll(
          '[class*="velocity-emi"],' +
          '[id*="velocity-emi"],' +
          '.velocity-emi-container,' +
          '.velocity-emi-widget'
        );


      knownElements.forEach(function (element) {

        element.remove();

      });


      /*
       * Remove dynamically injected
       * Velocity EMI blocks.
       */

      const candidates =
        stickyBar.querySelectorAll(
          'div, section, aside'
        );


      candidates.forEach(function (element) {


        /*
         * Never remove the actual
         * product buttons.
         */

        if (
          element.closest(
            '.custom-buy-buttons'
          )
        ) {

          return;

        }


        const text =
          (element.innerText || '')
            .replace(/\s+/g, ' ')
            .trim();


        if (
          text.length > 0 &&
          text.length < 250 &&
          /EMI/i.test(text) &&
          /Velocity/i.test(text)
        ) {

          element.remove();

        }

      });

    });

  }


  /*
   * Initial cleanup.
   */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      removeStickyEMI
    );

  } else {

    removeStickyEMI();

  }


  /*
   * Watch for dynamically injected
   * Velocity/EMI elements.
   */

  const observer =
    new MutationObserver(function () {

      removeStickyEMI();

    });


  if (document.body) {

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }

})();



/* =========================================================
   REMOVE VELOCITY EMI WIDGET FROM STICKY BUY BAR
   ========================================================= */

(function () {
  'use strict';


  function removeStickyEMI() {

    const stickyBars =
      document.querySelectorAll(
        '.product-form-buy-button'
      );


    stickyBars.forEach(function (stickyBar) {

      /*
       * First remove known Velocity classes.
       */
      const knownElements =
        stickyBar.querySelectorAll(
          '[class*="velocity-emi"], ' +
          '[id*="velocity-emi"], ' +
          '.velocity-emi-container, ' +
          '.velocity-emi-widget'
        );


      knownElements.forEach(
        function (element) {

          element.remove();

        }
      );


      /*
       * Remove dynamically injected EMI blocks.
       *
       * We only look at elements inside the
       * sticky product form area.
       */
      const candidates =
        stickyBar.querySelectorAll(
          'div, section, aside'
        );


      candidates.forEach(
        function (element) {

          /*
           * Do not remove our actual
           * Add to Cart / Quantity / Buy Now.
           */
          if (
            element.closest(
              '.product-form__buttons'
            )
          ) {
            return;
          }


          const text =
            (element.innerText || '')
              .replace(/\s+/g, ' ')
              .trim();


          /*
           * EMI widget in your screenshot contains
           * "EMI" and "Velocity".
           */
          if (
            text.length > 0 &&
            text.length < 250 &&
            /EMI/i.test(text) &&
            /Velocity/i.test(text)
          ) {

            element.remove();

          }

        }
      );

    });

  }


  /*
   * Initial cleanup.
   */
  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      removeStickyEMI
    );

  } else {

    removeStickyEMI();

  }


  /*
   * Watch for GoKwik/Velocity dynamically
   * inserting the EMI block.
   */
  const observer =
    new MutationObserver(
      function () {

        removeStickyEMI();

      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


})();